import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {map} from 'rxjs/operators';
import {PreviewActions, PreviewActionTypes} from "@ispm/test/store/preview/preview.actions";
import {PathwayPreviewService} from "@ispm/test/services/preview/pathway-preview.service";
import {CurationSettings} from "../../../../curation/components/curation-dashboard/curation-setting";
import {CurationActionCreatorService} from "../../../../curation/services/curation-action-creator.service";

@Injectable()
export class PreviewEffects {

  constructor(private actions$: Actions,
              private store$: Store<any>,
              private pathwayPreviewService: PathwayPreviewService
  ) {
  }

  // private getPathwayPreviewService(): PathwayPreviewService {
  //   return this.injector.get(PathwayPreviewService);
  // }

  @Effect({dispatch: false})
  startPathwayPreviewEffect$ = this.actions$.pipe(
    ofType<PreviewActions>(PreviewActionTypes.START_PREVIEW_PATHWAYS),

    map((action) => {

      const runPreviewMode = action.payload.runPreviewMode;
      const curationData = action.payload.curationData;
      const curationStatus = action.payload.curationStatus;
      const knowledgeBase = action.payload.knowledgeBase;
      if (runPreviewMode && curationData && curationStatus && knowledgeBase) {
          this.pathwayPreviewService.startRunPreview(runPreviewMode,
            curationData, curationStatus, knowledgeBase);
      }
    }));

}




